import React, { Component } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// STYLES
import styles from '../select.module.scss';

// MAIN COMPONENT

// eslint-disable-next-line react/prefer-stateless-function
class Control extends Component {
  render() {
    return <components.Control {...this.props} className={clsx('select-control', styles.control, this.props.className)} />
  }
}

export default Control
